
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soloists",
      function () {
        return require("private-next-pages/soloists/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soloists"])
      });
    }
  